import { APP_DEFAULT_PATH } from "config";
import { JSX, useEffect } from "react";
import { Navigate, Outlet } from "react-router";
import { MerchantSection, Role } from "types";
import { isMerchantSectionActive } from "utils";
import useStore from "zustand-store";

interface ProtectedRouteProps {
    roles: Role[];
    children?: JSX.Element;
    merchantSection?: MerchantSection;
};

const ProtectedRoute = ({ roles, children, merchantSection }: ProtectedRouteProps) => {
    const loggedUser = useStore(state => state.loggedUser);
    const merchant = useStore(state => state.professionalAccount);
    const logoutFront = useStore(state => state.logoutFront);

    useEffect(() => {
        if (!loggedUser) logoutFront();
    }, [loggedUser]);

    if (!loggedUser) {
        return <></>;
    }

    if (
        merchantSection &&
        (!merchant || !isMerchantSectionActive(merchant, merchantSection))
    ) {
        return <Navigate replace to={APP_DEFAULT_PATH} />;
    }
    
    if (roles.includes(loggedUser.role)) {
        return children || <Outlet />;
    }
    return <Navigate replace to={APP_DEFAULT_PATH}/>
}
 
export default ProtectedRoute;
